export default __webpack_public_path__ + "static/media/ultimate-frisbee.aa0ec0f1.svg";